import {Observable} from 'rxjs';
import {APIResponse} from '@core/interfaces/system/system-common';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {DownloadURL, PeriodFilter} from './load-forecast';

export abstract class DemandFactorService {
    /*
     * Demand factors
     */
    // Pivot data
    abstract getOrganicGrowthPivot(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        unit: string,
    ): Observable<DataSource>;

    abstract getLoadTransferPivot(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        unit: string,
    ): Observable<DataSource>;

    abstract getPhotovoltaicPivot(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        unit: string,
    ): Observable<DataSource>;

    abstract getElectricVehiclePivot(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        unit: string,
    ): Observable<DataSource>;

    abstract getLLAConnectionPivot(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        unit: string,
    ): Observable<DataSource>;

    abstract getLLADevelopPivot(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        unit: string,
    ): Observable<DataSource>;

    // Data download
    abstract getOrganicGrowthPivotCSV(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        unit: string,
    ): Observable<APIResponse<DownloadURL>>;

    abstract getLoadTransferPivotCSV(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        unit: string,
    ): Observable<APIResponse<DownloadURL>>;

    abstract getPhotovoltaicPivotCSV(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        unit: string,
    ): Observable<APIResponse<DownloadURL>>;

    abstract getElectricVehiclePivotCSV(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        unit: string,
    ): Observable<APIResponse<DownloadURL>>;

    abstract getLLADevelopPivotCSV(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        unit: string,
    ): Observable<APIResponse<DownloadURL>>;

    abstract getLLAConnectionPivotCSV(
        workflowItemId: number,
        scenarioId: string,
        period: PeriodFilter,
        unit: string,
    ): Observable<APIResponse<DownloadURL>>;
}
